<template>
   <n-config-provider :theme-overrides="themeOverrides" :locale="ruRU" :date-locale="dateRuRU">
    <n-loading-bar-provider>
      <n-message-provider placement="bottom-left">
        <n-notification-provider>
          <n-modal-provider>
            <n-dialog-provider>
               <router-view />
            </n-dialog-provider>
          </n-modal-provider>
        </n-notification-provider>
      </n-message-provider>
    </n-loading-bar-provider>
   </n-config-provider>
</template>

<script>
import { defineComponent } from "vue";
import { ruRU, dateRuRU } from 'naive-ui'

const themeOverrides = {
  common: {
    primaryColor: "#0AC0F8FF",
    primaryColorHover: "#0697FFFF",
    primaryColorPressed: "#0268B7FF",
    primaryColorSuppl: "#3672ADFF",
    fontWeight: "400",
    fontWeightStrong: "500",
    borderRadius: "8px",
    borderRadiusSmall: "4px",
    fontSize: "16px",
    fontSizeMini: "14px",
    bodyColor: "#f8f9fa"
  },
  PageHeader: {
    "titleFontSize": "22px"
  }
};
export default defineComponent({
  setup() {
      return {
        ruRU,
        dateRuRU,
        themeOverrides
      }
    }
});
</script>
<style scoped>
body, .n-layout-sider {
  background-color: #fff;
}

.n-layout-content {
  background-color: #f8f9fa;
  height: 100%;
  min-height: 100%;
}

</style>